export const ActionTypes = {
  REQUEST: "ADMIN_FETCH_USER_SUBCATEGORIES_REQUEST",
  SUCCESS: "ADMIN_FETCH_USER_SUBCATEGORIES_SUCCESS",
  FAILURE: "ADMIN_FETCH_USER_SUBCATEGORIES_FAILURE",

  SUCCESS_SINGLE: "ADMIN_FETCH_USER_SUBCATEGORY_SUCCESS",
  UPDATE_SUCCESS: "ADMIN_UPDATE_USER_SUBCATEGORY_SUCCESS",
  CREATE_SUCCESS: "ADMIN_CREATE_USER_SUBCATEGORY_SUCCESS",
  DELETE_SUCCESS: "ADMIN_DELETE_USER_SUBCATEGORY_SUCCESS",
}

export interface IUserSubcategory {
  id: number;
  custom_subcategory_name: string;
  date: string | null;
  description: string | null;
  parent_category: number;
  system_subcategory_name: number | null;
  system_subcategory_dataname: string | null;
  user: number;
  user_email: string;
}

interface NormalizedEntities {
  [key: string]: IUserSubcategory;
}

export interface IState {
  entities: NormalizedEntities;
  ids: string[];
  count: number;
  loading: boolean;
  error: any;
}